import { useDroppable } from "@dnd-kit/core";
import { FormattedMessage as FM } from "react-intl";
import { cn } from "tools/ui";
import OptionsColumn from "./OptionsColumn";

function HeaderColumn({
  title,
  count,
  color,
  isOver,
  // icon,
  showOptions = true,
  filterColumn,
  userFilter,
  setUserFilter,
  currentUserId,
  stateKey,
}) {
  const bgColor = color?.header || "bg-neutral-800";
  const border = `${color?.header}/30` || "bg-neutral-800";
  const textStyle = color?.textHeader || "text-neutral-100";

  return (
    <div
      className={cn(
        "flex items-center z-20 justify-between sticky top-0 px-4 rounded-t-md  transition-colors duration-200",
        bgColor,
        "text-white",
        isOver && "brightness-110",
      )}
    >
      {showOptions && (
        <OptionsColumn
          options={[]}
          filterColumn={filterColumn}
          userFilter={userFilter}
          setUserFilter={setUserFilter}
          currentUserId={currentUserId}
          columnKey={stateKey}
        />
      )}
      <div className="flex space-x-2 items-center ml-2">
        {color.icon && <span className={color?.textHeader}>{color.icon}</span>}
        <span className={cn("font-semibold text-lg  py-3 ", textStyle)}>
          <FM id={title} />
        </span>
      </div>
      <div className="border-l border-gray-300 py-3 pl-4">
        <div className={cn("h-full w-2 bg-gray-400", border)} />
        <span
          className={cn(
            "w-7 h-7   flex items-center  justify-center text-white text-2xl transition-transform duration-200 font-bold",
            isOver && "scale-110",
            textStyle,
          )}
        >
          {count ?? 0}
        </span>
      </div>
    </div>
  );
}

function Column({
  stateKey,
  title,
  count,
  color,
  children,
  model,
  isOverProp = false,
  icon,
  showOptions = true,
  filterColumn,
  userFilter,
  setUserFilter,
  currentUserId,
}) {
  const { setNodeRef, isOver } = useDroppable({
    id: stateKey,
    data: { column: stateKey },
  });

  const active = isOverProp || isOver;
  const _title = model ? `${model}.${title}` : title;

  return (
    <div
      ref={setNodeRef}
      className={cn(
        "w-full h-full rounded-md shadow-md flex flex-col border transition-all duration-200 overflow-hidden min-h-[300px] bg-gray-50 border-gray-300",
        active &&
          "bg-gray-50 border-blue-500/70 border-2 shadow-xl scale-[1.01]",
      )}
    >
      <HeaderColumn
        title={_title}
        count={count}
        color={color}
        isOver={active}
        model={model}
        icon={icon}
        showOptions={showOptions}
        filterColumn={filterColumn}
        userFilter={userFilter}
        setUserFilter={setUserFilter}
        currentUserId={currentUserId}
        stateKey={stateKey}
      />

      <div
        className={cn(
          "flex-1 space-y-5 p-4 overflow-y-auto max-h-max transition-colors duration-200 min-h-[120px] scroll-style",
          active && "bg-blue-50/50",
        )}
      >
        {children}
      </div>
    </div>
  );
}

export default Column;
